const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Rota da tela de um atendimento a partir do id OU do uuid.
 *
 * A tela `/tickets/:ticketId` lê o parâmetro como uuid (`GET /tickets/u/:uuid`),
 * mas a ação `openTicket` do runtime de plugins promete "abrir um ticket" pelo
 * `ticketId` — e plugin conhece o id numérico, que é o que vem nos eventos.
 * Mandar o número direto virava `/tickets/u/201405` e um 500 do backend
 * (22-09-2026). Número vira uuid por `GET /tickets/:id` antes de navegar.
 *
 * @param {number|string} ticketId  id numérico ou uuid
 * @param {(id: string) => Promise<{ uuid?: string } | null>} fetchTicket
 * @returns {Promise<string|null>} caminho, ou null se não der para abrir
 */
export async function ticketRoute(ticketId, fetchTicket) {
  const raw = String(ticketId ?? "").trim();
  if (!raw) return null;
  if (UUID.test(raw)) return `/tickets/${raw}`;
  if (!/^\d+$/.test(raw)) return null;
  const ticket = await fetchTicket(raw);
  return ticket && ticket.uuid ? `/tickets/${ticket.uuid}` : null;
}
